import { useState } from 'react';
import IcomoonIcon from 'components/common/Icon/IcomoonIcon';
import { DataCardTabsProps, EventAction } from 'plugins/types';
import { ManagementTag, S1Tag } from 'common/graphqlTypes';
import { ICON_COLORS } from 'styles/stylesProvider/themes';
import { manageTagsAction } from '../../actions/sentinel-one/actions';
import { TAGS_QUESTION_MARK_ICON } from '../DVEndpointDetailsRenderer.consts';
import EventActionsExecutor from '../../actions/sentinel-one/EventActionsExecutor';
import EndpointTagsEmptyState from './EndpointTagsEmptyState';
import EndpointTagsTable from './EndpointTagsTable';
import './DVEndpointDetailsTags.scss';

export const DVEndpointDetailsRendererTags = ({ initialData, values }: DataCardTabsProps): JSX.Element => {
  const tagsTableItems = initialData?.s1Endpoint?.tags || [];
  const tagsValues = tagsTableItems.reduce(
    (acc: ManagementTag[], tableItem: S1Tag) => [...acc, ...tableItem.value],
    [],
  );
  const numOfTags = tagsValues?.length;
  const tagsExists = numOfTags > 0;

  const [selectedAction, setSelectedAction] = useState<EventAction | null>(null);

  const getTagsState = tagsExists ? (
    <EndpointTagsTable tagsTableItems={tagsValues} />
  ) : values ? (
    <EndpointTagsEmptyState logEntry={values} />
  ) : (
    <></>
  );
  const setManageTagsButton = values && tagsExists && (
    <div>
      <div className="Tags__Separator"> </div>
      <span className="Tags__BorderLess__ManageButton" onClick={() => setSelectedAction(manageTagsAction)}>
        Manage Endpoint Tags
      </span>
      <EventActionsExecutor
        action={selectedAction}
        values={values}
        actionCompleteCallback={() => setSelectedAction(null)}
      />
    </div>
  );

  return (
    <div>
      <div className="Tags__Title">
        <span> Endpoint Tags ({numOfTags})</span>
        <span className="Tags__QuestionMarkIcon">
          <IcomoonIcon name={TAGS_QUESTION_MARK_ICON} size={16} color={ICON_COLORS.LINK} />
        </span>
        <div> {setManageTagsButton} </div>
      </div>
      {getTagsState}
    </div>
  );
};

export default DVEndpointDetailsRendererTags;
